<script>
export default {
  name: 'VolumeBar',
  props: {
    volume: {
      required: true,
      type: Number,
    },
  },
  computed: {
    barStyle () {
      return {
        width: `${Math.round(this.localValue * 100)}%`,
      };
    },
  },
  methods: {
    onInput () {
      this.editing = true;
      this.$emit('input', this.localValue);
    },
    onChange () {
      this.editing = false;
      this.$emit('change', this.localValue);
    },
    volumeUp () {
      this.$emit('change', Math.min(this.localValue + 0.1, 1));
    },
    volumeDown () {
      this.$emit('change', Math.max(this.localValue - 0.1, 0));
    },
  },
  data: () => ({
    localValue: 0,
    editing: false,
  }),
  watch: {
    volume: {
      immediate: true,
      handler (value) {
        if (!this.editing) this.localValue = value;
      },
    },
  },
};
</script>

<template lang="pug">
div.volume-bar.flex.items-center
  button.volumedownbtn.z-5.pa2(type="button", @click="volumeDown")
    icon.w1.fill-white(name="volume-down")
  div.bar.relative.flex-auto
    input.slider.absolute.z-2.absolute--fill(type="range", v-model.number="localValue", @input="onInput", @change="onChange", min="0", max="1", step="0.01")
    div.volumebar.h05.br4.db.bg-green.absolute.top-0.left-0.z-1(:style="barStyle")
    div.backgroundbar.h05.br4.db.bg-light-gray
  button.volumeupbtn.z-5.pa2(type="button", @click="volumeUp")
    icon.w1.fill-white(name="volume-up")
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import "styles/variables.css";

.volume-bar {
  & .backgroundbar {
    transition: box-shadow .2s ease-in-out;
  }
  &:hover {
    & .backgroundbar {
      box-shadow: 0 0 8px rgba(255, 255, 255), 0 0 30px rgba(255, 255, 255, .8);
    }
  }
  & .slider {

    &::range-thumb {
      height: 3rem;
      width:  3rem;

      border-radius: 100%;
      appearance: none;
      background: red;
    }
    appearance: none;
    left: -1.5rem;
    width: calc(100% + 3rem);
    opacity: 0;
    cursor: pointer;
  }
}
</style>
